"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseTextParams = void 0;
const parseTextParams = (textValue, paramObject) => {
    return Object.keys(paramObject).reduce((text, key) => text.replace(`$\{${key}}`, paramObject[key]), textValue);
};
exports.parseTextParams = parseTextParams;
